@if (component) {
<div class="w-12 pos-relative">
    <div class="ratio-hero-banner overflow-hidden"
         [class.overflow-hidden]="component.contentVariant  === contentVariant.video">
        <shell></shell>
        @if (component.image) {
        <img class="rf z-1"
             [image]="component.image" />
        }
        @if (component.contentVariant === contentVariant.video) {
        @if (component.contentVideoProvider === contentVideoProvider.vimeo) {
        <vimeo-player class="rf z-2"
                      [video-id]="component.contentVideoId"
                      [ngClass]="{'vimeo-player-full' : vimeoHeight && vimeoWidth}"
                      [background]="true"
                      [loop]="true"
                      (onPlayerInit)="onPlayerInit($event)">
        </vimeo-player>
        }
        @if (component.contentVideoProvider === contentVideoProvider.youtube) {
        <youtube-player class="rf z-2"
                        [video-id]="component.contentVideoId">
        </youtube-player>
        }
        }
    </div>
    <div class="pos-absolute top-0 left-0 z-2 fill w-12 mobile-overlayer"
         *ifSize="'MS'">
    </div>

    @switch (component.overlayText) {
    @case (true) {
    <text-overlay [data]="component"></text-overlay>
    }
    @default {
    <div class="w-12 pos-absolute top-50 col-w left-0 z-3 p-l-7 p-r-7 p-l-2-s p-r-2-s p-l-3-s p-r-3-s m-t-3 m-t-s-0 m-t-m-0"
         sizeClass="XL:no-transform"
         [ngClass]="component.text_alignment">
        <h1 [ngClass]="component.title_color">
            <p class="h1"
               [ngClass]="component.shadow ? '_text-shadow' : ''"
               *iCms="'title_top' of component"></p>
            <p class="hero m-t-2-s m-t-2-m"
               [ngClass]="component.shadow ? '_text-shadow' : ''"
               *iCms="'title_bottom' of component"></p>
        </h1>
        <ul class="m-t m-t-6-s m-t-6-m">
            @for (cta of component.ctas; track $index; let isLast = $last) {
            <li class="inline-block block-s m-t-6-s p-r-0-s"
                [ngClass]="{'p-r': !isLast}">
                @switch (cta.cta_type) {
                @default {
                <href [link]="cta.link">
                    <button [ngClass]="[cta.button, cta.shadow ? buttonShadow(cta.button) : '']">
                        <span *iCms="'text' of cta"></span>
                    </button>
                </href>
                }
                @case ('link_type') {
                <href class="underline"
                      [ngClass]="[cta.link_font_style || '', cta.link_color || '', cta.shadow ? '_text-shadow' : '']"
                      [link]="cta.link"
                      *iCms="'text' of cta"></href>
                }
                }
            </li>
            }
        </ul>
    </div>
    }
    }
</div>
}